import { USER_UPDATE } from '../../types/conversations'
import { 
  setActiveChannel,
  setActiveUser } from '../tabs'
import apiConversation from 'api/conversation'
import { setUnreadMessages } from './unreadMessagesAct'

const usersApi = apiConversation.users

export const success = (user) => ({ user, userId: user.id, type: USER_UPDATE })

export const selectUser = (user, channel) => (dispatch) => {
  dispatch(setActiveUser(user))
  dispatch(setUnreadMessages(user, 0))
  dispatch(setActiveChannel(channel))
}

export const updateUser = (user) => (dispatch) =>
  new Promise((resolve, reject) => {
    const userUpdate = Object.assign({}, user)
    usersApi
      .updateUser(userUpdate)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(success(data.results))
          resolve(data)
        } else {
          reject(data)
        }
      })
      .catch(reject)
  })
